import L from 'leaflet';
import { stoneMarkerSpec } from '../../fields.utils';

const SELECTED_COLOR = '#2154E8';
const FRONT_OFFSET = 10000;

const signatures = new WeakMap();

const iconOf = (spec, isSelected) => {
  const body = document.createElement('div');
  Object.assign(body.style, {
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    background: spec.fill,
    border: spec.border ?? '0',
    borderRadius: spec.shape === 'circle' ? '50%' : '2px'
  });
  if (isSelected) {
    const ring = document.createElement('div');
    Object.assign(ring.style, {
      position: 'absolute',
      left: '50%',
      top: '50%',
      boxSizing: 'border-box',
      width: `${spec.ringSize}px`,
      height: `${spec.ringSize}px`,
      transform: 'translate(-50%, -50%)',
      border: `2px solid ${SELECTED_COLOR}`,
      borderRadius: '50%',
      pointerEvents: 'none'
    });
    body.appendChild(ring);
  }
  return L.divIcon({
    className: 'stone-marker',
    html: body,
    iconSize: [spec.size, spec.size],
    iconAnchor: [spec.size / 2, spec.size / 2]
  });
};

const signatureOf = (spec, isSelected) =>
  [spec.shape, spec.size, spec.fill, spec.border, isSelected ? spec.ringSize : '-'].join(
    '|'
  );

const zOffsetOf = ({ isSelected, isListed }) => {
  if (isSelected) return FRONT_OFFSET;
  return isListed ? 0 : -FRONT_OFFSET;
};

export const createStoneMarker = (latlng, stone, state) => {
  const spec = stoneMarkerSpec({ stone, ...state });
  const marker = L.marker(latlng, {
    icon: iconOf(spec, state.isSelected),
    zIndexOffset: zOffsetOf(state),
    keyboard: false
  });
  signatures.set(marker, signatureOf(spec, state.isSelected));
  return marker;
};

export const restyleStoneMarker = (marker, stone, state) => {
  const spec = stoneMarkerSpec({ stone, ...state });
  const signature = signatureOf(spec, state.isSelected);
  if (signatures.get(marker) !== signature) {
    marker.setIcon(iconOf(spec, state.isSelected));
    signatures.set(marker, signature);
  }
  const zIndexOffset = zOffsetOf(state);
  if (marker.options.zIndexOffset !== zIndexOffset) marker.setZIndexOffset(zIndexOffset);
};
